import {getDatabase, ref, set, onValue, push, get, remove} from 'firebase/database';
import store from '../store'; // Importieren Sie den Store
export async function deleteUser(workshopId, userId){
    const customerId = store.getters.getCustomerId;
    const db = getDatabase();
    // Ref auf den Workshop
    const usersRef = ref(db, `customers/${customerId}/workshop/${workshopId}/users/${userId}`);
    // Löschen Sie den Benutzer
    await set(usersRef, null);
}
export async function onUsersChange(workshopId, callbackFunction){
    const customerId = store.getters.getCustomerId;
    const db = getDatabase();
    // Ref auf den Workshop

    // Erstellen Sie eine Referenz auf den Pfad der Benutzer im Workshop
    const usersRef = ref(db, `customers/${customerId}/workshop/${workshopId}/users`);

    onValue(usersRef, (snapshot) => {
        const usersObject = snapshot.val();
        if(usersObject == null){
            callbackFunction([])
        } else {
            callbackFunction(Object.keys(usersObject).map(key => {
                let val = usersObject[key];
                val.id = key;
                return val;
            }));
        }

    });

}

export async function loadWorkshop(customerId, workshopId){
    const db = getDatabase();
    // Ref auf den Workshop
    const workshopRef = ref(db, `customers/${customerId}/workshop/${workshopId}`);
    const snapshot = await get(workshopRef);
    console.log(snapshot.val());
    return snapshot.val();

}

export async function createWorkshop(customerId, companyName, name){
    const workshopId = Math.random().toString(16).slice(2);
    const db = getDatabase();
    // Ref auf den Workshop
    const workshopRef = ref(db, `customers/${customerId}/workshop/${workshopId}`);
    // Neues Element unter workshop/workshopId hinzufügen

    await set(workshopRef, {
        id: workshopId,
        startDate: null,
        name: name,
        companyName: companyName,
        users: [],
        activeVotingOnSegmentId: "",
        endVotingTime: null
    });

    return workshopId;
}
export async function startWorkshop(workshopId){
    const customerId = store.getters.getCustomerId;
    const db = getDatabase();
    // Ref auf den Workshop
    const workshopRef = ref(db, `customers/${customerId}/workshop/${workshopId}/startDate`);
    // Neues Element unter workshop/workshopId hinzufügen
    await set(workshopRef, new Date().getTime());/*
    const workshopUserRef = ref(db, `customers/${customerId}/workshop/${workshopId}/users`);
    // Neues Element unter workshop/workshopId hinzufügen
    await set(workshopUserRef, []);*/
    return workshopId;
}

//function to load customers
export async function loadCustomers(){
    const db = getDatabase();
    // Ref auf den Workshop
    const customersRef = ref(db, `customers`);
    const snapshot = await get(customersRef);
    return snapshot.val();
}

export async function createCustomer(name){
    const customerId = Math.random().toString(16).slice(2);
    const db = getDatabase();
    // Ref auf den Workshop
    const customerRef = ref(db, `customers/${customerId}`);

    await set(customerRef, {
        id: customerId,
        name: name,
        workshops: [],
    });

    return customerId;
}


export async function startVoting(workshopId, segmentId, durationInMIn){
    const customerId = store.getters.getCustomerId;
    const db = getDatabase();
    // Ref auf den Workshop
    const activeVotingRef = ref(db, `customers/${customerId}/workshop/${workshopId}/activeVoting`);
// Neues Element unter workshop/workshopId hinzufügen
    await set(activeVotingRef, {
        segmentId: segmentId,
        startTime: new Date().getTime(),
        endTime: new Date().getTime()+(durationInMIn*60*1000),
        votes: [],
    });
}

export async function setNewVotingEndTime(workshopId, newEndTime){
    const customerId = store.getters.getCustomerId;
    const db = getDatabase();
    // Ref auf den Workshop
    const activeVotingRef = ref(db, `customers/${customerId}/workshop/${workshopId}/activeVoting/endTime`);
// Neues Element unter workshop/workshopId hinzufügen
    await set(activeVotingRef, newEndTime);
}

export async function saveVoting(workshopId, segmentId, votes, voteWhereWantToBe, voteWhereWeAre){
    const customerId = store.getters.getCustomerId;
    const db = getDatabase();
    // Ref auf den Workshop
    const workshopRef = ref(db, `customers/${customerId}/workshop/${workshopId}/results/${segmentId}`);
// Neues Element unter workshop/workshopId hinzufügen
    await set(workshopRef, {
        id: segmentId,
        votes: votes,
        voteWhereWantToBe: voteWhereWantToBe,
        voteWhereWeAre: voteWhereWeAre,
    });
    return;
}

export async function deleteVoting(workshopId){
    const customerId = store.getters.getCustomerId;
    const db = getDatabase();
    // Ref auf den Workshop
    const activeVotingRef = ref(db, `customers/${customerId}/workshop/${workshopId}/activeVoting`);
// Neues Element unter workshop/workshopId hinzufügen
    await set(activeVotingRef, {});
}

export async function endVoting(workshopId){
    const customerId = store.getters.getCustomerId;
    const db = getDatabase();
    // Ref auf den Workshop
    const activeVotingRef = ref(db, `customers/${customerId}/workshop/${workshopId}/activeVoting/ended`);
// Neues Element unter workshop/workshopId hinzufügen
    await set(activeVotingRef, true);
}

export async function voting(workshopId, userId, userName, voteWhereWantToBe, voteWhereWeAre, duration){
    const customerId = store.getters.getCustomerId;
    const db = getDatabase();
    // Ref auf den Workshop
    const activeVotingRef = ref(db, `customers/${customerId}/workshop/${workshopId}/activeVoting/votes`);
// Neues Element unter workshop/workshopId hinzufügen
    await push(activeVotingRef, {
        userId: userId,
        userName: userName,
        duration: duration,
        voteWhereWantToBe: voteWhereWantToBe,
        voteWhereWeAre: voteWhereWeAre,
    });
}
export async function saveSelectedTopics(workshopId, selectedTopics){
    const customerId = store.getters.getCustomerId;
    const db = getDatabase();
    // Ref auf den Workshop
    const activeVotingRef = ref(db, `customers/${customerId}/workshop/${workshopId}/selectedTopics`);
// Neues Element unter workshop/workshopId hinzufügen
    await set(activeVotingRef, selectedTopics);
}
export async function saveWorkPlan(workshopId, workplan){
    const customerId = store.getters.getCustomerId;
    const db = getDatabase();
    // Ref auf den Workshop
    const activeVotingRef = ref(db, `customers/${customerId}/workshop/${workshopId}/workPlan`);
// Neues Element unter workshop/workshopId hinzufügen
    console.log(workplan)
    await set(activeVotingRef, workplan);
}
export async function saveNotice(workshopId, id, notice){
    const customerId = store.getters.getCustomerId;
    const db = getDatabase();
    // Ref auf den Workshop
    const activeVotingRef = ref(db, `customers/${customerId}/workshop/${workshopId}/notice/${id}`);
// Neues Element unter workshop/workshopId hinzufügen
    await set(activeVotingRef, notice);
}

export async function onNoticeChange(workshopId, callbackFunction){
    const customerId = store.getters.getCustomerId;
    const db = getDatabase();
    // Ref auf den Workshop

    // Erstellen Sie eine Referenz auf den Pfad der Benutzer im Workshop
    const activeVotingRef = ref(db, `customers/${customerId}/workshop/${workshopId}/notice`);

    onValue(activeVotingRef, (snapshot) => {
        callbackFunction(snapshot.val());
    });
}

export async function onActiveVotingChange(workshopId, callbackFunction){
    const customerId = store.getters.getCustomerId;
    const db = getDatabase();
    // Ref auf den Workshop

    // Erstellen Sie eine Referenz auf den Pfad der Benutzer im Workshop
    const activeVotingRef = ref(db, `customers/${customerId}/workshop/${workshopId}/activeVoting`);

    onValue(activeVotingRef, (snapshot) => {
        callbackFunction(snapshot.val());
    });
}
export async function onActiveVotingVotesChange(workshopId, callbackFunction){
    const customerId = store.getters.getCustomerId;
    const db = getDatabase();
    // Ref auf den Workshop

    // Erstellen Sie eine Referenz auf den Pfad der Benutzer im Workshop
    const activeVotingRef = ref(db, `customers/${customerId}/workshop/${workshopId}/activeVoting/votes`);

    onValue(activeVotingRef, (snapshot) => {
        if(snapshot.val() == null){
            callbackFunction([]);
        } else {
            callbackFunction(Object.values(snapshot.val()));
        }
    });
}

// Tasks laden
export async function loadTasks(customerId, workshopId) {
    const db = getDatabase();
    const tasksRef = ref(db, `customers/${customerId}/workshop/${workshopId}/tasks`);
    const snapshot = await get(tasksRef);
    const tasks = snapshot.val();
    return tasks
        ? Object.values(tasks).map((task) => ({
            ...task,
            dueDate: new Date(task.dueDate),
            dirtyFlags: {}, // Initialisiere dirtyFlags für jedes Feld
        }))
        : [];
}


// Task speichern
export async function saveTask(customerId, workshopId, task) {
    task.dueDate = task.dueDate.getTime();
    const db = getDatabase();
    const taskRef = ref(db, `customers/${customerId}/workshop/${workshopId}/tasks/${task.id}`);
    await set(taskRef, task);
}

// Task hinzufügen
export async function addTask(customerId, workshopId, task) {
    const db = getDatabase();
    const taskRef = ref(db, `customers/${customerId}/workshop/${workshopId}/tasks`);

    // Use push() to generate a unique ID and create a new child reference
    const newTaskRef = push(taskRef);
    const taskId = newTaskRef.key;

    // Remove undefined values and add default properties
    const sanitizedTask = Object.fromEntries(
        // eslint-disable-next-line no-unused-vars
        Object.entries(task).filter(([_, value]) => value !== undefined)
    );

    sanitizedTask.id = taskId; // Assign the generated ID to the task
    sanitizedTask.dueDate = sanitizedTask.dueDate || new Date().toISOString(); // Default dueDate

    await set(newTaskRef, sanitizedTask);
    return taskId; // Return the generated ID
}

// Task löschen
export async function deleteTask(customerId, workshopId, taskId, trackerKey, tracker) {
    let successfullyDeleted = false;
    if(trackerKey){
        successfullyDeleted = await tracker.deleteIssue(trackerKey);
    } else {
        successfullyDeleted = true;
    }

    const db = getDatabase();
    const taskRef = ref(db, `customers/${customerId}/workshop/${workshopId}/tasks/${taskId}`);
    await remove(taskRef);
    return successfullyDeleted;
}

export async function checkConflickts(task, tracker){
    return await checkConflict(task.trackerKey, task, tracker);
}

export async function updateIssue(customerId, workshopId, task, tracker) {
    try {
        if (!tracker) {
            throw new Error("Tracker is not configured");
        }

        // Check if the task already exists in the tracker
        if (task.trackerKey) {
            console.log(`Updating issue ${task.trackerKey} in the tracker`);

            // Update existing issue in the tracker
            const updatedKey = await tracker.updateIssue(task.trackerKey, task);

            let duedate = task.dueDate;
            if(!(duedate instanceof Date)){
                duedate = new Date(duedate);
            }

            const originalTask = {
                summary: task.summary,
                assignee: task.assignee,
                parentIssue: task.parentIssue,
                qualityAspect: task.qualityAspect,
                dueDate: duedate.getTime(),
                originalEffort: task.originalEffort,
                description: task.description,
            };

            console.log(`Issue ${updatedKey} updated successfully`);
            task.originalValues = {
                ...originalTask
            }
            // Reset dirty flags after a successful update
            for (const key in task.dirty) {
                task.dirty[key] = false;
            }

            // Save the updated task with the tracker key to Firebase
            await saveTask(customerId, workshopId, task);
        } else {
            console.log("Creating new issue in the tracker");
            let duedate = task.dueDate;
            if(!(duedate instanceof Date)){
                duedate = new Date(duedate);
            }
            const newtask = {
                summary: task.summary,
                assignee: task.assignee,
                parentIssue: task.parentIssue,
                qualityAspect: task.qualityAspect,
                dueDate: duedate.getTime(),
                originalEffort: task.originalEffort,
                description: task.description,
            };
            // Create a new issue in the tracker
            const newKey = await tracker.createIssue(newtask);
            task.originalValues = {
                ...newtask
            }

            // Reset dirty flags after a successful update
            for (const key in task.dirty) {
                task.dirty[key] = false;
            }

            console.log(`New issue created with key ${newKey}`);

            // Update the task with the tracker key
            task.trackerKey = newKey;

            // Save the updated task with the tracker key to Firebase
            await saveTask(customerId, workshopId, task);
        }
    } catch (error) {
        console.error("Error updating issue", error);
        throw error;
    }
}

/**
 * Check for conflicts between local and Jira data
 * @param {string} issueKey - Jira issue key
 * @param {Object} localIssue - Locally stored issue with original values and dirty flags
 * @returns {Object} - Object with conflict details
 */
export async function checkConflict(issueKey, localIssue, tracker) {
    // Fetch the latest issue data from Jira
    const trackerIssue = await tracker.getIssue(issueKey);

    const conflicts = {};

    // Map local fields to Jira fields for comparison
    const fieldMapping = {
        summary: "summary",
        dueDate: "duedate",
        assignee: "assignee",
        description: "description",
        parentIssue: "parent",
        labels: "labels",
        qualityAspect: "qualityAspect",
    };

    for (const [localField, jiraField] of Object.entries(fieldMapping)) {
        const localOriginal = localIssue.originalValues[jiraField];
        const trackerFieldCurrent = trackerIssue[jiraField];
        const localDirty = localIssue.dirty[localField];

        if (localDirty && localOriginal !== undefined) {
            // Check if Jira has changed since the last fetch
            if (localOriginal !== trackerFieldCurrent) {
                conflicts[localField] = {
                    localOriginal,
                    trackerFieldCurrent,
                    localDirtyValue: localIssue[localField],
                };
            }
        }
    }

    return conflicts;
}


